import {Component, OnInit} from '@angular/core';
import {CardActivationImport} from '../../../../dto/card-activation-import';
import {CardActivationImportError} from '../../../../dto/card-activation-import-error';
import {ActivatedRoute, Router} from '@angular/router';
import {DatePipe} from '@angular/common';
import {DateFormats} from '../../../../providers/app-date-adapter';
import {CardActivation} from '../../../../dto/card-activation';
import {CardActivationImportService} from '../../../services/card-activation-import.service';
import {MatTableDataSource} from '@angular/material/table';
import {ImportErrorSeverity} from '../../../../dto/import-error-severity';

@Component({
  selector: 'app-card-activation-import-view',
  templateUrl: './card-activation-import-view.component.html',
  styleUrls: ['./card-activation-import-view.component.css']
})
export class CardActivationImportViewComponent implements OnInit {

  import: CardActivationImport;
  importData: CardActivation[];
  importErrors: CardActivationImportError[];

  importDataDataSource: MatTableDataSource<CardActivation>;
  importErrorsDataSource:  MatTableDataSource<CardActivationImportError>;

  importCols = [
    { header: 'ID',           cell: (row: CardActivationImport) => `${row.id}`},
    { header: 'Date',         cell: (row: CardActivationImport) => `${this.datePipe.transform(row.date, DateFormats.DisplayDateTime)}`},
    { header: 'User',         cell: (row: CardActivationImport) => `${row.username}`},
    { header: 'Info rows', cell: (row: CardActivationImport) => `${row.infoRowCount}`},
    { header: 'Warning rows', cell: (row: CardActivationImport) => `${row.warningRowCount}`},
    { header: 'Error rows', cell: (row: CardActivationImport) => `${row.invalidRowCount}`},
    { header: 'Total rows',   cell: (row: CardActivationImport) => `${row.totalRowCount}`},
  ];

  importDataCols = [
    { columnDef: 'token',          header: 'Token',           cell: (row: CardActivation) => `${row.token}` },
    { columnDef: 'activationDate', header: 'Activation Date', cell: (row: CardActivation) => `${this.datePipe.transform(row.activationDate, DateFormats.DisplayDateTime)}` },

  ];

  importErrorsCols = [
    { columnDef: 'severity',   header: 'Severity',   cell: (row: CardActivationImportError) => ImportErrorSeverity[row.severity], getClass:( row: CardActivationImportError ) => this.getImportRowClass(row) },
    { columnDef: 'rowNumber',   header: 'Row number',   cell: (row: CardActivationImportError) => `${row.rowNumber}`},
    { columnDef: 'ParsedValue', header: 'Parsed value', cell: (row: CardActivationImportError) => `${row.parsedValue}`},
    { columnDef: 'errorText',   header: 'Error Text',   cell: (row: CardActivationImportError) => `${row.errorText}`, getClass:( row: CardActivationImportError ) => this.getImportRowClass(row)},
  ];

  constructor(
    private importService: CardActivationImportService,
    private router: Router,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
  ) { }

  ngOnInit() {
    const id = parseInt(this.route.snapshot.paramMap.get('id'));
    this.importService.get(id).subscribe(result => {
      this.import = result;
      this.importDataDataSource = new MatTableDataSource(result.cardActivations);
      this.importErrorsDataSource = new MatTableDataSource(result.importErrors);
    });
  }

  getRowClass = (item: CardActivation): string => item.importErrorsText ? 'warning-row' : '';

  getImportRowClass = (item: CardActivationImportError): string => {
    switch (item.severity) {
      case ImportErrorSeverity.Critical:
        return 'critical-row';
      case ImportErrorSeverity.Error:
        return 'error-row';
      case ImportErrorSeverity.Warning:
        return 'warning-row';
      case ImportErrorSeverity.Info:
        return 'info-row';

    }
    return '';
  };
}
